var _g, _g2, _g3, _g4, _g5, _g6, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgSecurity = function SvgSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 104,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#security_svg__filter0_d_1047_10086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 63a1.5 1.5 0 10-1.5-1.502v.008c0 .828.671 1.494 1.5 1.494z",
    fill: "#33AA40"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#security_svg__filter1_d_1047_10086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.515 67.537l-9.262-5.006V45.61c0-3.176-2.244-5.76-5.003-5.76h-1.47v-3.648c0-6.706-2.623-13.028-7.387-17.8C56.628 13.628 50.318 11 43.624 11c-6.692 0-13 2.629-17.764 7.402-4.764 4.774-7.387 11.095-7.387 17.801v3.647h-1.47c-2.759 0-5.003 2.585-5.003 5.761v8.932c0 .89.72 1.613 1.61 1.613.89 0 1.61-.722 1.61-1.613v-8.931c0-1.351.833-2.536 1.783-2.536H70.25c.95 0 1.782 1.185 1.782 2.535v16.92l-9.275 5.012c-1.521.822-2.454 1.448-2.475 3.846-.034 3.8 1.048 7.86 3.127 11.742.131.245.265.486.4.724H17.003c-.95 0-1.782-1.185-1.782-2.535v-12.4c0-.89-.721-1.612-1.61-1.612-.89 0-1.611.722-1.611 1.612v12.4c0 3.176 2.244 5.76 5.003 5.76h48.91c1.664 2.213 3.51 3.937 5.521 5.14.867.52 1.538.78 2.21.78.67 0 1.34-.26 2.207-.78 3.087-1.85 5.786-4.908 8.022-9.09 2.079-3.882 3.16-7.942 3.126-11.74-.02-2.404-.957-3.03-2.484-3.853zM57.89 39.85H29.363v-3.647c0-7.882 6.397-14.294 14.261-14.294 7.867 0 14.266 6.413 14.266 14.294v3.647zm7.668 0h-4.447v-3.647c0-4.655-1.827-9.048-5.142-12.37-3.316-3.32-7.7-5.15-12.346-5.15-4.645 0-9.029 1.83-12.343 5.152s-5.14 7.714-5.14 12.368v3.647h-4.447v-3.647c0-12.118 9.838-21.977 21.93-21.977 12.095 0 21.935 9.859 21.935 21.977v3.647zm15.474 41.756c-1.929 3.61-4.293 6.322-6.836 7.847-.31.186-.472.266-.554.301a4.936 4.936 0 01-.556-.302c-1.814-1.086-3.492-2.72-5.013-4.873l-.026-.037a28.425 28.425 0 01-1.8-2.937c-1.825-3.405-2.774-6.928-2.745-10.188a3.37 3.37 0 01.043-.608c.131-.098.453-.272.741-.428l9.356-5.055 9.302 5.029.044.023c.29.156.614.331.746.43.016.075.04.25.043.61.029 3.259-.92 6.782-2.745 10.188z",
    fill: "#33AA40"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#security_svg__filter2_d_1047_10086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.566 57h13.868C62.3 57 63 56.328 63 55.5s-.701-1.5-1.566-1.5H47.566C46.7 54 46 54.672 46 55.5s.7 1.5 1.566 1.5z",
    fill: "#33AA40"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#security_svg__filter3_d_1047_10086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.602 66h9.795c.885 0 1.603-.895 1.603-2s-.718-2-1.603-2h-9.795c-.885 0-1.602.895-1.602 2s.717 2 1.602 2z",
    fill: "#33AA40"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#security_svg__filter4_d_1047_10086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 73.888C20 76.155 21.884 78 24.2 78h15.595C42.114 78 44 76.155 44 73.888c0-2.986-1.352-5.983-3.708-8.223a12.906 12.906 0 00-2.96-2.106c1.867-1.509 3.058-3.79 3.058-6.34 0-4.532-3.765-8.219-8.393-8.219-4.625 0-8.387 3.687-8.387 8.219 0 2.549 1.19 4.83 3.055 6.34a12.9 12.9 0 00-2.96 2.107C21.35 67.905 20 70.902 20 73.888zM31.997 52.22c2.814 0 5.103 2.242 5.103 4.997 0 2.756-2.29 4.997-5.103 4.997-2.81 0-5.097-2.241-5.097-4.997 0-2.755 2.287-4.997 5.097-4.997zm0 13.216c4.478 0 8.712 4.107 8.712 8.45 0 .484-.418.891-.914.891H24.2c-.493 0-.91-.408-.91-.89 0-4.344 4.232-8.451 8.707-8.451z",
    fill: "#33AA40"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#security_svg__filter5_d_1047_10086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.159 73.482l-4.73 4.683-1.642-1.483a1.697 1.697 0 00-2.34.074 1.559 1.559 0 00.077 2.259l2.826 2.554c.32.288.726.431 1.132.431.43 0 .861-.162 1.185-.483l5.863-5.804a1.558 1.558 0 00-.03-2.26 1.698 1.698 0 00-2.341.03z",
    fill: "#33AA40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "security_svg__filter0_d_1047_10086",
    x: 4,
    y: 52,
    width: 19,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.439216 0 0 0 0 0.807843 0 0 0 0 0.270588 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1047_10086"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1047_10086",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "security_svg__filter1_d_1047_10086",
    x: 4,
    y: 3,
    width: 91,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.439216 0 0 0 0 0.807843 0 0 0 0 0.270588 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1047_10086"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1047_10086",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "security_svg__filter2_d_1047_10086",
    x: 38,
    y: 46,
    width: 33,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.439216 0 0 0 0 0.807843 0 0 0 0 0.270588 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1047_10086"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1047_10086",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "security_svg__filter3_d_1047_10086",
    x: 38,
    y: 54,
    width: 29,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.439216 0 0 0 0 0.807843 0 0 0 0 0.270588 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1047_10086"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1047_10086",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "security_svg__filter4_d_1047_10086",
    x: 12,
    y: 41,
    width: 40,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.439216 0 0 0 0 0.807843 0 0 0 0 0.270588 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1047_10086"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1047_10086",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "security_svg__filter5_d_1047_10086",
    x: 60,
    y: 65,
    width: 28,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.439216 0 0 0 0 0.807843 0 0 0 0 0.270588 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1047_10086"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1047_10086",
    result: "shape"
  })))));
};

export default SvgSecurity;